export function getBreadCrumbsProps(breadCrumbs) {
    const pixelToLetterRatio = 13;
    const breadCrumbsLength = breadCrumbs.length;
    const lastItemLength =
        (breadCrumbs[breadCrumbsLength - 1] && breadCrumbs[breadCrumbsLength - 1].title.length) ||
        0;
    const secondLastItemLength =
        (breadCrumbsLength &&
            breadCrumbs[breadCrumbsLength - 2] &&
            breadCrumbs[breadCrumbsLength - 2].title.length) ||
        0;
    const currentWidth = pixelToLetterRatio * (lastItemLength + secondLastItemLength);

    const breadCrumbsWidth = breadCrumbs.reduce((total, item) => {
        return total + item.title.length * pixelToLetterRatio;
    }, 0);

    return {
        currentWidth,
        pixelToLetterRatio,
        breadCrumbsWidth,
        breadCrumbsLength
    };
}
